






















import Vue from "vue";
import { RootState } from "@/store";
import { mapState } from "vuex";

import { SensorCalibration } from "@/model/data/logAnalysis/SensorCalibration";

export default Vue.extend({
    props: {
        sensorCalibrationList: Array,
        sensorsLabels: Map,
        loading: Boolean,
        startDate: Date,
        dateListString: Array,
        nDays: Number,
    },
    data() {
        return {
            seriesSCTrendList: [],
        };
    },
    computed: {
        ...mapState({
            userTheme: (state: RootState) => state.authMod.currentUser.userConfig.theme,
        }),
        chartSensorCalibrationTrend() {
            return {
                options: {
                    theme: {
                        mode: this.userTheme,
                    },
                    chart: {
                        type: "line",
                        zoom: {
                            enabled: true,
                        },
                        animations: {
                            enabled: false,
                        },
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    stroke: {
                        curve: "straight",
                    },
                    grid: {
                        row: {
                            colors: ["#f3f3f3", "transparent"],
                            opacity: 0.5,
                        },
                        xaxis: {
                            lines: {
                                show: false,
                            },
                        },
                    },
                    xaxis: {
                        type: "category",
                        categories: this.dateListString,
                    },
                    yaxis: {
                        labels: {
                            formatter: (value) => {
                                if (value != null) {
                                    return value % 1 == 0 ? value.toFixed(0) : value.toFixed(2);
                                }
                                return null;
                            },
                        },
                    },
                    tooltip: {
                        shared: false,
                        y: {
                            formatter: (value) => (value != null ? value.toFixed(2) : null),
                        },
                    },
                    markers: {
                        size: 4,
                        colors: undefined,
                        strokeColors: "#fff",
                        strokeWidth: 2,
                        strokeOpacity: 0.9,
                        strokeDashArray: 0,
                        fillOpacity: 1,
                        discrete: [],
                        shape: "circle",
                        radius: 2,
                        offsetX: 0,
                        offsetY: 0,
                        onClick: undefined,
                        onDblClick: undefined,
                        showNullDataPoints: true,
                    },
                },
                series: this.seriesSCTrendList,
            };
        },
    },
    watch: {
        sensorCalibrationList: {
            handler(value) {
                this.seriesSCTrendList = [];
                if (value && value.length) {
                    let sensorCalibrationMap = new Map<number, Array<SensorCalibration>>();
                    this.sensorCalibrationList.forEach((sc) => {
                        let utcDate = Date.UTC(sc.dateTime.getFullYear(), sc.dateTime.getMonth(), sc.dateTime.getDate(), 0, 0, 0);
                        let dayIndex = Math.floor((utcDate - this.startDate.getTime()) / (1000 * 3600 * 24));
                        if (!sensorCalibrationMap.has(sc.sensorNum)) sensorCalibrationMap.set(sc.sensorNum, new Array(this.nDays).fill(null));
                        sensorCalibrationMap.get(sc.sensorNum)[dayIndex] = sc;
                    });
                    sensorCalibrationMap.forEach((value, key) => {
                        let data = [];
                        value.forEach((sc, i) => {
                            if (sc == null) {
                                if (i > 0) data.push(data[i - 1]);
                                else data.push(null);
                            } else data.push(sc.averageCalibrationLevel);
                        });
                        this.seriesSCTrendList.push({ name: this.sensorsLabels.get(key.toString()), data: data });
                    });
                }
            },
            deep: true,
            immediate: true,
        },
    },
});
